export function initSectionHeadings() {
    if (!window.matchMedia('(min-width: 1025px)').matches) {
        return;
    }

    const sectionHeadings = document.querySelectorAll('.section-heading');

    sectionHeadings.forEach((heading) => {
        const block = heading.closest('.block');

        if (!block) return;

        // Get the height of the heading
        const headingHeight = heading.offsetHeight;

        // Set the heading height as a CSS variable
        heading.style.setProperty('--heading-height', `${headingHeight}px`);

        // Make heading visible
        heading.classList.add('visible');

        // Skip fixed positioning for hero headers
        if (block.classList.contains('block-hero-header')) {
            return;
        }

        // Track animation frame request
        let ticking = false;

        // Function to update heading position
        const updatePosition = () => {
            const blockRect = block.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            // Check if block has scrolled up enough and extends below viewport
            if (
                blockRect.top + 350 <= windowHeight / 2 &&
                blockRect.bottom > windowHeight
            ) {
                heading.classList.add('is-fixed');
            } else {
                heading.classList.remove('is-fixed');
            }

            ticking = false;
        };

        // Scroll handler with requestAnimationFrame
        const onScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    updatePosition();
                });
                ticking = true;
            }
        };

        // Add scroll event listener
        window.addEventListener('scroll', onScroll, { passive: true });

        // Initial position check
        updatePosition();
    });
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', () => {
    initSectionHeadings();
});
